import { render } from "./DarkBasicTemplate.vue?vue&type=template&id=c344ee42&scoped=true"
import script from "./DarkBasicTemplate.vue?vue&type=script&lang=js"
export * from "./DarkBasicTemplate.vue?vue&type=script&lang=js"

import "./DarkBasicTemplate.vue?vue&type=style&index=0&id=c344ee42&scoped=true&lang=css"

import exportComponent from "C:\\tapfactor-max\\tapfactor\\frontend_tapfactor\\tapfactorprofile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c344ee42"]])

export default __exports__